import { render, staticRenderFns } from "./UpdateDetailsPopup.vue?vue&type=template&id=3aa5af6a&scoped=true"
import script from "./UpdateDetailsPopup.vue?vue&type=script&lang=js"
export * from "./UpdateDetailsPopup.vue?vue&type=script&lang=js"
import style0 from "./UpdateDetailsPopup.vue?vue&type=style&index=0&id=3aa5af6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa5af6a",
  null
  
)

export default component.exports